import { createContext, useContext } from 'react'

const I18nPreviewContext = createContext<boolean>(false)

// eslint-disable-next-line i18next/no-literal-string
const I18N_PREVIEW_CONTEXT_DISPLAY_NAME = 'I18n Preview Context'
I18nPreviewContext.displayName = I18N_PREVIEW_CONTEXT_DISPLAY_NAME

export const useI18nPreviewContext = (): boolean => {
  return useContext(I18nPreviewContext)
}

export default I18nPreviewContext
